import React, { useState } from 'react'

import { CompanyData } from '@driftt/api-types'
import { Header } from '@driftt/dds'
import { A, Avatar, CircleLoader, Div } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

import Card from 'components/Card'
import { prefixUrlWithHttp } from 'utils/urlUtils'

import styles from './styles.module.css'

interface Props {
  company: CompanyData | null
}

const CompanyDataSection = (props: Props) => {
  const { company } = props
  const [isOpen, setIsOpen] = useState(true)

  if (company === null) {
    return (
      <Card>
        <CircleLoader />
      </Card>
    )
  }

  return (
    <Card>
      <Div className={styles.sectionHeader}>
        <Div className={styles.iconHeader}>
          <Avatar className={styles.sectionAvatar} type="company" size="mini" company={company} />
          <Header variant="h4">{company.name}</Header>
        </Div>
        <Div className={styles.collapseIcon} onClick={() => setIsOpen(!isOpen)}>
          <Icon name={isOpen ? 'chevron-down' : 'chevron-up'} width={12} />
        </Div>
      </Div>
      {isOpen && (
        <Div className={styles.sectionContent}>
          <Div className={styles.field}>
            <Div className={styles.fieldLabel}>Website</Div>
            <A href={prefixUrlWithHttp(company.url)} target="_blank">
              <Div>{company.url || '-'}</Div>
            </A>
          </Div>
          <Div className={styles.field}>
            <Div className={styles.fieldLabel}>Location</Div>
            <Div>{company.address || company.location || '-'}</Div>
          </Div>
          <Div className={styles.field}>
            <Div className={styles.fieldLabel}>Employee count range</Div>
            <Div>{company.employeeCountRange || company.employeeCount || '-'}</Div>
          </Div>
          <Div className={styles.field}>
            <Div className={styles.fieldLabel}>Category</Div>
            <Div>{company.industry || '-'}</Div>
          </Div>
          <Div className={styles.field}>
            <Div className={styles.fieldLabel}>Estimated Annual Revenue</Div>
            <Div>{company.revenueRange || company.revenue || '-'}</Div>
          </Div>
          <Div className={styles.field}>
            <Div className={styles.fieldLabel}>About</Div>
            <Div>{company.description || company.about || '-'}</Div>
          </Div>
        </Div>
      )}
    </Card>
  )
}

export default CompanyDataSection
